import React from "react";
import { Routes, Route } from "react-router-dom";
import TrainingList from "./list";
import TrainingView from "./view";

export default function Training() {
  return (
    <Routes>
      <Route index element={<TrainingList />} />
      <Route path=":id" element={<TrainingView />} />
    </Routes>
  );
}
